// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1111":"abe8cb0e","5336":"a8f6ed53","8957":"591ee56b"}[chunkId] + ".chunk.css";
};